exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".linkCursor {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/purchasing/po-branch-to-branch/po-branch-to-branch.component.scss
// module id = ../../../../../src/app/agatextscreens/purchasing/po-branch-to-branch/po-branch-to-branch.component.scss
// module chunks = 0